import { takeLatest, all, call, put } from 'redux-saga/effects';
import {
    setPage,
    setRowsPerPage,
    startAddingNewCostingCard,
    startAllCostingCards,
    setCostCard,
    startCustomerCostingDetails,
    setCustomerCostingDetails,
    startStandardCostingCard,
    setStandardCostingCards,
    completedAction,
    setNewCardName,
    startMakingDefaultCosting,
    //
    startInvoiceList,
    setInvoiceList,
    startAddingNewInvoice,
    startInvoiceDetailsById,
    startDownloadInvoiceExcel,
    setInvoiceDetails,
    startCertificateList,
    setCertificateList,
    setGeneratedId
} from './costingInvoicing.slice';
import {
    getcostingCards,
    getStandardCostings,
    addNewcostingCards,
    updateCostingCardAsStandard,
    cardCostingDetails,
    getCertificatesList,
    addInvoice,
    getInvoiceList,
    getInvoiceDetailsById,
    getInvoiceListByColumnFilter,
    downloadInvoiceExcelFile
} from 'utils/apis/costing';

import { openSnackbar } from '../snackbar';
// Saga handlers
// Costing Cards Response (1)
function* costingCardsResponseHandler() {
    try {
        const response = yield call(getcostingCards);
        yield put(setCostCard(response));
        yield put(completedAction());
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}
//  Costing Cards Watcher (1)
function* startCostingCardsWatcher() {
    yield takeLatest(startAllCostingCards.type, costingCardsResponseHandler);
}
///
// Standard CostingCard Response (2)
function* standardCostingCardResponseHandler() {
    try {
        const response = yield call(getStandardCostings);
        yield put(setStandardCostingCards(response));
        yield put(completedAction());
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}
//  Standard Costing Card Watcher (2)
function* standardCostingCardsWatcher() {
    yield takeLatest(startStandardCostingCard.type, standardCostingCardResponseHandler);
}

// Adding New Costing Cards (3)
function* addNewCostingCardResponseHandler({ payload }) {
    try {
        yield call(addNewcostingCards, payload);
        yield put(setNewCardName(''));
        yield put(
            openSnackbar({
                open: true,
                message: 'Added Successfully',
                variant: 'alert',
                alert: {
                    color: 'success'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(startAllCostingCards());
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}

// Adding New Costing Cards (3)
function* addNewCostingCardsWatcher() {
    yield takeLatest(startAddingNewCostingCard.type, addNewCostingCardResponseHandler);
}

// update Costing Card As Standard (4)
function* defaultMarkingCardResponseHandler({ payload }) {
    try {
        yield call(updateCostingCardAsStandard, payload);
        yield put(startAllCostingCards());
        yield put(
            openSnackbar({
                open: true,
                message: 'Updated Successfully',
                variant: 'alert',
                alert: {
                    color: 'success'
                },
                close: false,
                actionButton: false
            })
        );
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}

// update Costing Card As Standard (4)
function* startMakingDefaultCostingWatcher() {
    yield takeLatest(startMakingDefaultCosting.type, defaultMarkingCardResponseHandler);
}

// start Certificate List (5)
function* startCertificateListResponseHandler({ payload }) {
    try {
        const response = yield call(getCertificatesList, payload);
        yield put(setCertificateList(response));
        yield put(completedAction());
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}

// start Certificate List (5)
function* startCertificateListWatcher() {
    yield takeLatest(startCertificateList.type, startCertificateListResponseHandler);
}

///
// start Certificate List (5)
// eslint-disable-next-line consistent-return
function* startAddingNewInvoiceWatcherResponseHandler({ payload }) {
    try {
        const response = yield call(addInvoice, payload);
        yield put(setGeneratedId(response?.invoice_id));
        yield put(
            openSnackbar({
                open: true,
                message: response?.message,
                variant: 'alert',
                alert: {
                    color: 'success'
                },
                close: false,
                actionButton: false
            })
        );
        return 'Testing';
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}

// start Certificate List (5)
function* startAddingNewInvoiceWatcher() {
    yield takeLatest(startAddingNewInvoice.type, startAddingNewInvoiceWatcherResponseHandler);
}
//
// setInvoiceList,
//     startInvoiceList,

// start Invoice List (6)
function* startInvoiceListWatcherResponseHandler({ payload }) {
    try {
        const response = yield call(getInvoiceListByColumnFilter, payload);
        yield put(setInvoiceList(response));
        yield put(completedAction());
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}

function* downloadInvoiceExcelHandler({ payload }) {
    try {
        yield call(downloadInvoiceExcelFile, payload);
        yield put(completedAction());
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}

// start Invoice List (6)
function* startInvoiceListeWatcher() {
    yield takeLatest(startInvoiceList.type, startInvoiceListWatcherResponseHandler);
}

function* startDownloadInvoiceExcelWatcher() {
    yield takeLatest(startDownloadInvoiceExcel.type, downloadInvoiceExcelHandler);
}
//
//
// start Invoice Details By ID (7)
function* startInvoiceDetailsByIdWatcherResponseHandler({ payload }) {
    try {
        const response = yield call(getInvoiceDetailsById, payload);

        yield put(setInvoiceDetails(response));
        yield put(completedAction());
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedAction());
    }
}

// start Invoice Details By ID (7)
function* startInvoiceDetailsByIdWatcher() {
    yield takeLatest(startInvoiceDetailsById.type, startInvoiceDetailsByIdWatcherResponseHandler);
}
//

// startCertificateList,
// setCertificateList

// Accumulator
export default function* costingDataSaga() {
    yield all([
        call(startCostingCardsWatcher),
        call(standardCostingCardsWatcher),
        call(addNewCostingCardsWatcher),
        call(startMakingDefaultCostingWatcher),
        call(startCertificateListWatcher),
        call(startAddingNewInvoiceWatcher),
        call(startInvoiceListeWatcher),
        call(startDownloadInvoiceExcelWatcher),
        call(startInvoiceDetailsByIdWatcher)
    ]);
}
